import React from "react";
import {
  Route,
  Redirect,
  RouteProps,
  RouteComponentProps,
} from "react-router-dom";
import { IonProgressBar } from "@ionic/react";
import { useAuth } from "@/hooks/useAuth";

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  return (
    <>
      {isLoading && (
        <IonProgressBar
          type="indeterminate"
          style={{
            position: "fixed",
            top: "var(--ion-safe-area-top, 0)",
            zIndex: 9999,
          }}
        />
      )}
      {!isLoading && (
        <Route
          {...rest}
          render={(props) => {
            // Not authenticated -> redirect to welcome
            if (!isAuthenticated) {
              return (
                <Redirect
                  to={{
                    pathname: "/auth/welcome",
                    state: { from: props.location },
                  }}
                />
              );
            }

            // Authenticated and organisation selected -> render component
            return <Component {...props} />;
          }}
        />
      )}
    </>
  );
};

export default PrivateRoute;
